import { colors, fonts } from '@grupoboticario/flora-tokens/gbInstitucional/web/ds'

export const gbInstitucional = {
  colors,
  fonts,
}
